













import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { cleanHistoryData } from '@/utils/api/setting'
import MyDialog from './MyDialog.vue'

@Component({
  components: {
    MyDialog,
  },
})
export default class ClearUpHistoryData extends Vue {
  @Prop({ default: false }) public visible!: boolean

  private showDialog: boolean = this.visible

  @Watch('visible')
  private onVisibleChanged(val: boolean) {
    this.showDialog = val
  }

  private async cleanData() {
    cleanHistoryData()
    this.$message.success(this.$tc('connections.cleanHistorySuccess'))
    this.resetData()
  }

  private resetData() {
    this.showDialog = false
    this.$emit('update:visible', false)
  }
}
